import { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import { TextIconButtonComponent } from "../../../../component/atom";
import DialogComponent from "../../../../component/atom/Dialog/Dialog";
import {
  AdminQuestionView,
  PopUpMessageComponent,
  DocumentAssociationDialog,
  QandACard,
} from "../../../../component/molecule";
import { useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import { AdminQuestionsEdit } from "../../../../component/molecule/Forms";
import { useQuestionEdit } from "../../../../hook/useQuestionEdit";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import { useQuizFolders } from "../../../../hook/useQuizFolders";
import { useQuizForm } from "../../../../hook/useQuizForm";
import QuizFormBody from "../../../../component/molecule/Cards/admin/QuizFormBody";
import { useActiveQuizData, ASSOCIATION_ACTION } from "../../../../core/Constant";

const AdminQuizViewScreen = ({
  getQuizById,
  reduxQuizData,
  questionAndAnswersList,
  getQuizQuestionAndAnswerByQuizId,
  removeQuestionfromQuiz
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const id = location.state?.id;
  const locationQuizData = location.state?.quizData;
  const folderId =
    location.state?.folderId ??
    JSON.parse(sessionStorage.getItem("quiz_active_folder_id") || "null");
  const courseId =
    location.state?.courseId ??
    JSON.parse(sessionStorage.getItem("quiz_active_course_id") || "null");
  const breadcrumbTrail =
    location.state?.breadcrumbTrail ??
    JSON.parse(sessionStorage.getItem("quiz_breadcrumb_trail") || "null");

  const { folders, loadingFolders } = useQuizFolders();

  const { baseUrl, activeQuizData } = useActiveQuizData(
    reduxQuizData,
    locationQuizData,
    location.state
  );

  const quizForm = useQuizForm(activeQuizData);

  const [questionList, setQuestionList] = useState([]);
  const [viewQuestion, setViewQuestion] = useState(false);
  const [isdeletequestion, setIsDeleteQuestion] = useState(false);

  const {
    selectedItem,
    setSelectedItem,
    showEditWarning,
    editQuestion,
    editingQuestionId,
    associateQuizzes,
    handleEditQuestion,
    onConfirmEdit,
    onCancelEdit,
    onEditQuestionClose,
  } = useQuestionEdit();

  const handleBackNavigation = () => {
    navigate("/admin-quiz-main", {
      state: {
        folderId: folderId ?? null,
        courseId: courseId ?? null,
        breadcrumbTrail: breadcrumbTrail ?? null,
      },
    });
  };

  useEffect(() => {
    if (id) {
      getQuizById(id);
      getQuizQuestionAndAnswerByQuizId(id)
    }
  }, [id, getQuizById, getQuizQuestionAndAnswerByQuizId]);

  useEffect(() => {
    setQuestionList(questionAndAnswersList || []);
  }, [questionAndAnswersList]);

  const onViewOff = () => {
    setViewQuestion(false);
    setSelectedItem({});
  };

  const handleViewQuestion = (question) => {
    setSelectedItem(question);
    setViewQuestion(true);
  };

  const handleEditQuestionClose = () => {
    onEditQuestionClose(() => {
      if (id) getQuizQuestionAndAnswerByQuizId(id);
    });
  };

  const handleDeleteQuestion = (question) => {
    setSelectedItem({
      ...question,
      id: question?.id ?? question?.question_id,
    });
    setIsDeleteQuestion(true);
  };

  const onDeleteQuestion = () => {
    setIsDeleteQuestion(false)
    removeQuestionfromQuiz({
      quiz_id: id,
      question_id: selectedItem?.id ?? selectedItem?.question_id,
    })
    onDeleteClose();
  };

  const onDeleteClose = () => {
    setIsDeleteQuestion(false);
    setSelectedItem({});
  };

  return (
    <>
      <Box className="main-screen-container">
        <Grid container direction="row" justifyContent="space-between">
          <Grid item>
            <HeadingComponent
              text={"Quiz Details"}
              fontweigth={600}
              size={40}
              backNavigation={true}
              onBackClick={handleBackNavigation}
              fontfamily={"Montserrat"}
            />
          </Grid>

          <Grid item className="student-search-btn-section" columnGap={2}>
            {id ? (<Box>
              <TextIconButtonComponent
                btnText={"Show Result In Graph"}
                icon={faChartLine}
                onclick={() => {
                  navigate('/admin-quiz-attempt-result', { state: { quiz: { id }, type: '0' } })
                }}
              />
            </Box>
            ) : null}
          </Grid>
        </Grid>

        <QuizFormBody
          form={quizForm}
          folderItems={folders}
          loadingFolders={loadingFolders}
          courseList={quizForm.clist}
          isViewOnly={true}
          baseUrl={baseUrl}
        />

        <Box sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={2}>
            <Grid xs={12} item >
              {
                questionList.map((question, index) => (
                  <QandACard
                    item={question}
                    index={index}
                    key={question?.id || index}
                    isView={true}
                    isEdit={true}
                    isDelete={true}
                    onclick={() => handleViewQuestion(question)}
                    onPressEdit={() => handleEditQuestion(question, activeQuizData?.quiz_name || activeQuizData?.name)}
                    isEditing={editingQuestionId === (question?.id ?? question?.question_id)}
                    onPressDelete={() => handleDeleteQuestion(question)}
                  />
                ))
              }
            </Grid>
          </Grid>
        </Box>
      </Box>
      {showEditWarning && (
        <DocumentAssociationDialog
          association={{
            data: associateQuizzes,
            action: ASSOCIATION_ACTION.EDIT,
            entityType: "question",
            entityName: (selectedItem?.question || selectedItem?.name || "").replace(/<[^>]*>/g, ""),
          }}
          onConfirm={onConfirmEdit}
          onClose={onCancelEdit}
        />
      )}
      <DialogComponent
        isShowCloseButton={true}
        title={"View Question"}
        maxwidth={"lg"}
        open={viewQuestion}
        onClose={onViewOff}
      >
        <AdminQuestionView item={selectedItem} onClose={() => onViewOff()} />
      </DialogComponent>
      <DialogComponent
        isShowCloseButton={true}
        title={"Edit Question"}
        maxwidth={"lg"}
        open={editQuestion}
        onClose={handleEditQuestionClose}
      >
        <AdminQuestionsEdit
          questionDetails={selectedItem}
          onClose={handleEditQuestionClose}
        />
      </DialogComponent>
      <PopUpMessageComponent
        open={isdeletequestion}
        type={"other"}
        title={"Delete!"}
        message={"Are you sure you want to delete this question??"}
        btntext={"Yes, delete"}
        altbtntext={"No"}
        onclick={onDeleteQuestion}
        altonclick={onDeleteClose}
        onclose={onDeleteClose}
      />
    </>
  );
};

export default connect(
  (state) => ({
    reduxQuizData:
      state.quizes?.get?.("quizData") ||
      state.quizes?.quizData ||
      state.quizes?.get?.("quiz") ||
      state.quizes?.quiz,
    questionAndAnswersList: state.quizes?.get?.("questionAndAnswersList") ||
      state.quizes?.questionAndAnswersList,
  }),
  {
    getQuizById: Actions.quizes.getQuizById,
    getQuizQuestionAndAnswerByQuizId:
      Actions.quizes.getQuizQuestionAndAnswerByQuizId,
    removeQuestionfromQuiz: Actions.quizes.removeQuestionfromQuiz,
  }
)(AdminQuizViewScreen);